import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Header from "./Header";

export default function BlogView() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchArticle = async () => {
      try {
        setLoading(true);
        const response = await fetch(`https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch article');
        }
        const data = await response.json();
        setArticle(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchArticle();
    }
  }, [id]);

  //   if (loading) return <p>Loading article...</p>;
  //   if (error) return <p style={{ color: 'red' }}>{error}</p>;
  //   if (!article) return <p>Article not found.</p>;
  return (
    <div className="blog_page_wrapper">
      <Header />
      <div className="banner">
        <div style={{ width: "100%", position: "relative" }}>
          {article?.thumbnailUrl && <img src={article?.thumbnailUrl} alt="" />}
          {/* <Image
            src="/blog_view.jpg" // or your URL
            alt="Sample"
            fill // This makes the image fill the parent container
            style={{ objectFit: "cover" }} // Optional: cover, contain, etc.
            priority // Optional: preload image
          /> */}
        </div>
      </div>
      <a href="/" className="back_btn_blog">View All Articles</a>
      <div className="blog_content_wrapper">
        <h1>
          {article?.title}
        </h1>
        <p className="subtitle">{article?.subtitle}</p>
        <div className="author">
          <div className="left">
            {article?.authorImage && <img src={article?.authorImage} alt="" width={50} height={50} ></img>}

            {/* <img src="/logo192.png" alt="" width={50} height={50} ></img> */}

          </div>
          <div className="right">
            <p>{article?.authorName}</p>
            <p className="date"> {moment(article?.createdAt).format("MMMM Do YYYY")}  </p>
          </div>
        </div>

        <div dangerouslySetInnerHTML={{ __html: article?.description }} className="editor_content"></div>
      </div>
    </div>
  );
}
